import React from "react";
import { Login } from "../containers";

export default function LoginPage() {
    return <Login />;
}
